<template>
  <navigation-layout ref='navigationlayout'>
    <h1 slot="title">{{title}}</h1>
    <h3 slot="abstract">{{abstract}}</h3>
    <main>
      <form novalidate class="md-layout" @submit.prevent="validateUsername">
        <field fieldName="username" ref="username" :validations="{required: true}" :fieldValue=form.username
          fieldLabel="Username" fieldId="username" :sending="sending" @setfield="setFormField($event)" />
        <md-radio v-model="form.accountkind" :value=0>Standard</md-radio>
        <md-radio v-model="form.accountkind" :value=1>Integration</md-radio>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 right-align">
            <md-button type="submit" class="md-raised md-primary" :disabled="sending">Save</md-button>
          </div>
        </div>
      </form>
    </main>
  </navigation-layout>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import NotificationService from '@/services/notificationService'
import Field from '@/components/elements/field'

export default {
  name: 'ConvertAccount',
  data: () => ({
    form: {
      username: null,
      accountkind: null
    },
    title: 'Convert account',
    abstract: 'Search an account by username and convert account',
    sending: false
  }),
  components: {
    NavigationLayout,
    Field
  },
  methods: {
    async validateUsername () {
      var results = []
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].validateField) {
          results.push(await this.$refs[property].validateField())
        }
      }
      var canSave = results.every((value) => {
        return value
      })
      if (canSave && this.form.accountkind !== null) {
        this.sending = true
        await NotificationService.manageNotification(this, await RepositoryService.setAccountKind(this.form),
          (data) => { this.$refs.navigationlayout.setNotification('Account changed with success') })
        this.sending = false
      }
    },
    setFormField (fieldObj) {
      this.form[fieldObj.fieldName] = fieldObj.fieldValue
    }
  }
}

</script>

<style lang="scss" scoped>
  .right-align {
    text-align: right;
  }

</style>
